import { render, staticRenderFns } from "./JUpload.vue?vue&type=template&id=47cd76b8&scoped=true&"
import script from "./JUpload.vue?vue&type=script&lang=js&"
export * from "./JUpload.vue?vue&type=script&lang=js&"
import style0 from "./JUpload.vue?vue&type=style&index=0&id=47cd76b8&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47cd76b8",
  null
  
)

export default component.exports